import React from 'react';

// Small building blocks shared by the dashboard widgets. All colours come from
// the Dashboard theme object `T` so widgets follow light / dark mode.

export const TONES = {
  red:   { bg: 'rgba(239,68,68,0.12)',  fg: '#ef4444' },
  amber: { bg: 'rgba(245,158,11,0.15)', fg: '#d97706' },
  blue:  { bg: 'rgba(59,130,246,0.14)', fg: '#3b82f6' },
  green: { bg: 'rgba(16,185,129,0.14)', fg: '#059669' },
  grey:  { bg: 'rgba(148,163,184,0.18)', fg: '#64748b' },
};

export const Badge = ({ tone = 'grey', children }) => (
  <span style={{ fontSize: 10.5, fontWeight: 700, borderRadius: 20, padding: '2px 8px', background: TONES[tone].bg, color: TONES[tone].fg, whiteSpace: 'nowrap' }}>{children}</span>
);

export const Row = ({ T, title, sub, right, onClick, last }) => (
  <div onClick={onClick}
    style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: last ? 'none' : `1px solid ${T.border}`, cursor: onClick ? 'pointer' : 'default' }}>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 12.5, fontWeight: 600, color: T.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</div>
      {sub ? <div style={{ fontSize: 11, color: T.text3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{sub}</div> : null}
    </div>
    {right}
  </div>
);

// Loading / error / empty handling so each widget only writes its happy path.
export function WidgetState({ T, state, empty, children }) {
  if (state.loading && !state.data) {
    return (
      <div style={{ padding: '10px 0' }}>
        {[70, 90, 55].map((w, i) => <div key={i} style={{ height: 10, width: `${w}%`, borderRadius: 6, background: T.border, margin: '12px 0', opacity: 0.6 }} />)}
      </div>
    );
  }
  if (state.error && !state.data) {
    return <p style={{ fontSize: 12, color: T.text3, padding: '14px 0', margin: 0 }}>Could not load this widget. {state.error}</p>;
  }
  if (empty) return <p style={{ fontSize: 12.5, color: T.text3, textAlign: 'center', padding: '22px 0', margin: 0 }}>{empty}</p>;
  return children;
}

export function Donut({ parts, size = 130, thickness = 18, center, T }) {
  const r = (size - thickness) / 2, c = 2 * Math.PI * r;
  const total = parts.reduce((a, p) => a + p.value, 0) || 1;
  let offset = 0;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ flex: 'none' }}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={T.border} strokeWidth={thickness} />
      {parts.filter(p => p.value > 0).map((p, i) => {
        const len = c * p.value / total;
        const el = <circle key={i} cx={size / 2} cy={size / 2} r={r} fill="none" stroke={p.color} strokeWidth={thickness}
          strokeDasharray={`${len} ${c - len}`} strokeDashoffset={-offset} transform={`rotate(-90 ${size / 2} ${size / 2})`} />;
        offset += len;
        return el;
      })}
      <text x="50%" y="50%" textAnchor="middle" dominantBaseline="central" fontSize="22" fontWeight="800" fill={T.text}>{center}</text>
    </svg>
  );
}

export const linkBtn = (T) => ({ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: 11.5, fontWeight: 600, color: '#6366f1' });
